import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'react-bootstrap';
import ReactGA from 'react-ga4';

const trackingId = 'G-VWYVMX1FEM';
ReactGA.initialize(trackingId);

const usePageTracking = () => {
  useEffect(() => {
    const sendPageView = () => {
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
    };

    sendPageView();

    const handleRouteChange = () => {
      sendPageView();
    };

    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);
};

const Analytics = () => {
  usePageTracking();

  useEffect(() => {
    reportWebVitals(({ id, name, value }) =>
      ReactGA.event({
        action: name,
        category: 'Web Vitals',
        label: id,
        nonInteraction: true,
        value: Math.round(name === 'CLS' ? value * 1000 : value),
      })
    );
  }, []);

  return null;
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
      <Analytics />
    </ThemeProvider>
  </React.StrictMode>
);

// Function to send web vitals to Google Analytics
const sendToAnalytics = ({ id, name, value }) => {
  ReactGA.event({
    action: name,
    category: 'Web Vitals',
    label: id,
    nonInteraction: true,
    value: Math.round(name === 'CLS' ? value * 1000 : value),
  });
};

// Send performance metrics to Google Analytics
reportWebVitals(sendToAnalytics);